/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';

export interface DeleteCustomerFeedMill$Params {
  customerFeedMillId: number;
}

export function deleteCustomerFeedMill(http: HttpClient, rootUrl: string, params: DeleteCustomerFeedMill$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
  const rb = new RequestBuilder(rootUrl, deleteCustomerFeedMill.PATH, 'delete');
  if (params) {
    rb.path('customerFeedMillId', params.customerFeedMillId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerFeedMill>;
    })
  );
}

deleteCustomerFeedMill.PATH = '/api/customer/feedMill/{customerFeedMillId}';
